import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import layout from '@/common/layout'

Vue.use(Router)

const router = new Router({
    // mode: 'history',  //去掉url中的#
    routes: [
        {
            path: '/appIndex',
            component: () => import('./views/app/appIndex.vue'),
            meta: { auth: false }
        }, {

            path: '/employeeAppeal',
            component: () => import('./views/app/employeeAppeal.vue'),
            meta: { auth: false }
        },
        {
            path: '/detailList',
            component: () => import('./views/app/detailList.vue'),
            meta: { auth: false }
        },
        {
            path: '/myList',
            meta: { auth: false },
            component: () => import('./views/move/myList.vue')
        }, {
            path: '/xwDetail',
            meta: { auth: false },
            component: () => import('./views/xw/xwDetail.vue')
        }, {
            path: '/moveDetail',
            meta: { auth: false },
            component: () => import('./views/move/moveDetail.vue')
        }, {
            path: '/carList',
            meta: { auth: false },
            component: () => import('./views/move/carList.vue')
        }, {
            path: '/myCarList',
            meta: { auth: false },
            component: () => import('./views/move/myCarList.vue')
        }, {
            path: '/issueTask',
            meta: { auth: false },
            component: () => import('./views/task/issueTask.vue')
        }, {
            path: '/approvalTask',
            meta: { auth: false },
            component: () => import('./views/task/approvalTask.vue')
        },{
            path: '/launchEvent',
            meta: { auth: false },
            component: () => import('./views/activity/launchEvent.vue')
        }, {
            path: '/approvalActivitiesNoe',
            meta: { auth: false },
            component: () => import('./views/activity/approvalActivitiesNoe.vue')
        }, {
            path: '/approvalActivitiesTwo',
            meta: { auth: false },
            component: () => import('./views/activity/approvalActivitiesTwo.vue')
        }, {
            path: '/updateImg',
            meta: { auth: false },
            component: () => import('./views/activity/updateImg.vue')
        }, {
            path: '/applicants',
            meta: { auth: false },
            component: () => import('./views/activity/applicants.vue')
        }, {
            path: '/fundApplication',
            meta: { auth: false },
            component: () => import('./views/fund/fundApplication.vue')
        }, {
            path: '/fundActivities',
            meta: { auth: false },
            component: () => import('./views/fund/fundActivities.vue')
        }, {
            path: '/activityOverview',
            meta: { auth: false },
            component: () => import('./views/activity/activityOverview.vue')
        }, {
            path: '/activityImg',
            meta: { auth: false },
            component: () => import('./views/activity/activityImg.vue')
        }, {
            path: '/myCar',
            meta: { auth: false },
            component: () => import('./views/move/myCar.vue')
        },
        {
            path: '/groupActivities',
            meta: { auth: false },
            component: () => import('./views/activity/groupActivities.vue')
        },
        {
            path: '/groupApproval',
            meta: { auth: false },
            component: () => import('./views/activity/groupApproval.vue')
        },
        {
            path: '/appealList',
            name:'appealList',
            meta: { auth: true },
            component: () => import('./views/app/appealList.vue')
        },
        {
            path: '/appealDetail',
            name:'appealDetail',
            meta: { auth: true },
            component: () => import('./views/app/appealDetail.vue')
        },
        {
            path: '/',
            name: 'layout',
            component: layout,
            meta: { keepAlive: true },
            redirect: '/home',
            children: [
                {
                    path: 'home',
                    meta: { auth: true, keepAlive: true },
                    component: () => import('./views/xw/homeA.vue')
                },
                {
                    path: 'search',
                    meta: { auth: true },
                    component: () => import('./views/xw/search.vue')
                },
                {
                    path: 'personalCenter',
                    meta: { auth: true },
                    component: () => import('./views/xw/personalCenter.vue')
                }
            ]
        }

    ]
})
export default router
